import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Tour } from "antd";

import MainLayout from "components/MainLayout";
import Company from "./components/Company";
import IssueKinds from "./components/IssueKinds";
import CompanyQrCode from "./components/CompanyQrCode";
import MainPageIntro from "./components/MainPageIntro";
import Logotype from "./components/Logotype";
import ModalDeleteCompany from "./components/ModalDeleteCompany";

import { useIssueKinds } from "context/providers/issue_kinds";

const Settings = () => {
  const { data } = useIssueKinds();
  const [is_open_initial_tour, setOpenInitialTour] = useState(false);
  const [is_open_edit_tour, setOpenEditTour] = useState(false);

  const create_issue_kind_ref = useRef(null);
  const first_issue_kind_ref = useRef(null);
  const initial_steps = [
    {
      title: <h1 style={{ margin: 0 }}>Witaj w konfiguratorze!</h1>,
      description: (
        <h3 style={{ margin: 0 }}>
          Rozpocznij proces dodawania rodzajów zgłoszeń.
        </h3>
      ),
      nextButtonProps: { children: "Dalej" },
    },
    {
      title: <h2 style={{ margin: 0 }}>Dodaj rodzaj zgłoszenia</h2>,
      description: (
        <h3 style={{ margin: 0 }}>
          Kliknij, aby dodać typ zgłoszenia. Po wprowadzeniu nazwy zostaniesz
          przeniesiona/y do edycji typu zgłoszenia.
        </h3>
      ),
      target: () => create_issue_kind_ref.current,
      prevButtonProps: { children: "Wróć" },
      nextButtonProps: { children: "Ok" },
    },
  ];

  const edit_steps = [
    {
      title: <h2 style={{ margin: 0 }}>Edycja</h2>,
      description: (
        <h3 style={{ margin: 0 }}>
          Kliknij, aby przejść do edycji rodzaju zgłoszenia.
        </h3>
      ),
      target: () => first_issue_kind_ref.current,
      nextButtonProps: { children: "OK" },
    },
  ];

  useEffect(() => {
    if (!data?.length) {
      setOpenInitialTour(true);
    }
  }, [data.length]);

  return (
    <MainLayout breadcrumbs={[{ name: "Ustawienia", path: "/settings" }]}>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={24} lg={24} xl={8}>
          <Logotype />
          <Company />
          <CompanyQrCode />
          <ModalDeleteCompany />
        </Col>
        <Col xs={24} md={24} lg={24} xl={16}>
          <MainPageIntro />
          <IssueKinds
            create_issue_kind_ref={create_issue_kind_ref}
            first_issue_kind_ref={first_issue_kind_ref}
            setOpenEditTour={setOpenEditTour}
          />
        </Col>
      </Row>
      <Tour
        open={is_open_initial_tour}
        steps={initial_steps}
        onClose={() => setOpenInitialTour(false)}
      />
      <Tour
        open={is_open_edit_tour}
        steps={edit_steps}
        onClose={() => setOpenEditTour(false)}
      />
    </MainLayout>
  );
};

export default Settings;
